import React, { useEffect, useState, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLoader } from '../../contexts/LoaderContext';
import { checkAuthentication } from '../../utils/checkAuthentication';
import { Sidebar } from '../Sidebar/Sidebar';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { MobileHeader } from '../MobileHeader/MobileHeader';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, refreshAuth, logout, userData } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [isChecked, setIsChecked] = useState(false);
  const { width } = useWindowDimensions();

  const handleAuthCheck = useCallback(async () => {
    const authChecked = await checkAuthentication(
      isChecked,
      { refreshAuth, logout },
      { showLoader, hideLoader }
    );
    setIsChecked(authChecked);
  }, [refreshAuth, logout, showLoader, hideLoader, isChecked]);

  useEffect(() => {
    handleAuthCheck();
  }, [handleAuthCheck]);

  if (!isChecked) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  return (
    <main className="page">
      {userData && width > 768 && (
        <Sidebar firstName={userData?.firstName} lastName={userData?.lastName} />
      )}
      {userData && width < 768 && (
        <MobileHeader firstName={userData?.firstName} lastName={userData?.lastName} />
      )}

      <section className="page-content">{children}</section>
    </main>
  );
};
